
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["share-icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"38","viewBox":"0 0 52 52"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"26","cy":"26","fill":"#f37b8a","r":"26"}}),_c('path',{attrs:{"d":"M35.601 18.248a.84.84 0 01.819.819V34.26a.84.84 0 01-.819.819h-19a.84.84 0 01-.819-.819V19.082a.84.84 0 01.819-.818h19m0-2.125h-19a2.955 2.955 0 00-2.949 2.943v15.179a2.955 2.955 0 002.944 2.944h19a2.955 2.955 0 002.944-2.944V19.082a2.955 2.955 0 00-2.939-2.944z"}}),_c('path',{attrs:{"d":"M26.098 28.979a1.063 1.063 0 01-.691-.253l-8.035-6.795a1.069 1.069 0 111.373-1.638l7.353 6.229 7.355-6.229a1.064 1.064 0 111.371 1.626l-8.046 6.794a1.063 1.063 0 01-.68.266z"}})])
          )
        }
      }
    